module.exports = __webpack_public_path__ + "img/instagram.2de810a5.svg";